// /src/layouts/MainLayout.jsx
/* eslint-disable */
import React from "react";
import styled from "styled-components";
import BottomNav from "../components/BottomNav";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppConfig } from "../context/AppConfigContext";
import { useDriverStatusContext } from "context/DriverStatusContext";
import GlobalNotificationToast from "components/GlobalNotificationToast";

/* ===== 세션 유틸 (HomePage와 동일 패턴) ===== */
const getSession = () => {
    try {
        return JSON.parse(localStorage.getItem("dhm.session") || "null");
    } catch {
        return null;
    }
};
const isGuestSession = (s) => !s || s.auth !== "user";

const BAR_HEIGHT = 60; // BottomNav 대략 높이(+ safe-area는 컴포넌트 내부에서 처리)

export default function MainLayout({ children, showBottomNav = true }) {
    const nav = useNavigate();
    const loc = useLocation();

    // AppConfig 접근관리
    const { config } = useAppConfig();
    const accessCfg = config.access || {};
    const guardFaq = accessCfg.faq || {}; // 🔹 FAQ 전용 가드 설정 (AdminAccessControl에서 관리)

    // 드라이버 상태 (HomePage와 동일 기준 사용)
    const { status, grade } = useDriverStatusContext();
    const session = getSession();
    const isGuest = isGuestSession(session);

    // “가맹 기사 & 게스트 등급 아님” 기준
    const isSalesAllowed = status === "member" && grade !== "guest";

    // active 키 추출 (home/faq/my)
    const active =
        loc.pathname.startsWith("/faq") ? "faq" :
            loc.pathname.startsWith("/my") ? "my" :
                "home";

    const showGuardMessage = (message, fallback) => {
        window.alert(message || fallback);
    };

    // 네비게이션 래퍼: 여기서 FAQ 가드 처리
    const handleNavigate = (path) => {
        // 🔹 FAQ 전용 가드 (하단 탭에서 FAQ 누를 때)
        // if (path.startsWith("/faq")) {
        //     // 1) 가드 OFF면 누구나 이용 가능
        //     if (!guardFaq.enabled) {
        //         nav(path);
        //         return;
        //     }

        //     // 2) 기본 정책: “헤이웨이 가맹 기사 전용”
        //     //    → 게스트이거나, member가 아니거나, grade가 guest면 막기
        //     if (isGuest || !isSalesAllowed) {
        //         showGuardMessage(
        //             guardFaq.message,
        //             "헤이웨이 가맹 기사 전용 서비스입니다.\n관리자에게 문의해 주세요."
        //         );
        //         return;
        //     }

        //     // 3) 여기까지 통과하면 FAQ 이동 허용
        //     nav(path);
        //     return;
        // }

        // 나머지 경로는 그대로 네비게이트
        nav(path);
    };

    return (
        <Wrap>
            <GlobalNotificationToast />
            <Content
                id="main-scroll"
                style={{ paddingBottom: showBottomNav ? BAR_HEIGHT + 12 : 12 }}
            >
                {children}
            </Content>

            {showBottomNav && (
                <BottomNav
                    active={active}
                    navigate={handleNavigate}
                />
            )}
        </Wrap>
    );
}

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;
